import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

import Image from '@components/atoms/image/image';
import Copy from '@components/atoms/copy/copy';

import { mq, px2rem, getTextType } from '@stylesheets/tools';

const StyledScrollIndicator = styled(motion.div)`
  margin: auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  display: none;

  ${mq('xl')} {
    display: flex;
  }

  img {
    width: 80px;
  }

  p {
    ${getTextType('subline')}
    font-size: ${px2rem('22px')} !important;
    display: none;

    ${mq('xxl')} {
      display: block;
    }
  }
`;

const ScrollIndicator = ({ className }) => {
  return (
    <StyledScrollIndicator
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1.4, duration: 0.4, ease: 'linear' }}
    >
      <motion.div
        animate={{ y: [0, -5, 0] }}
        transition={{
          duration: 2,
          ease: 'easeInOut',
          repeat: Infinity,
          repeatDelay: 1
        }}
      >
        <Image src="/static/images/scroll.png" />
      </motion.div>

      <Copy uppercase>Scroll to Explore</Copy>
    </StyledScrollIndicator>
  );
};

ScrollIndicator.propTypes = {
  className: PropTypes.string
};

export default ScrollIndicator;
